export function isOnline (state) {
  return state.isOnline
}
